module.exports = __webpack_public_path__ + "static/media/trainVideo4.fdefa5d2.mp4";